import _ from 'lodash';

import { WidgetRegistry } from '../registry';
import { flowedDescendants, isStretchedWidget } from './flexContext';

function alignmentMarginLeftPx(containerWidget, breakpoint, containingBlockWidth) {
  const minWidth = _.get(containerWidget, `properties.${breakpoint}.container.minWidth`);
  if (!minWidth) return 0;

  const alignment =
    _.get(containerWidget, `properties.${breakpoint}.container.alignment.position`) ||
    _.get(containerWidget, `properties.${breakpoint}.container.alignment`, 'center');
  const multiplier = alignment === 'left' ? 0 : alignment === 'right' ? 1 : 0.5;

  return (containingBlockWidth - minWidth) * multiplier;
}

function freezeWidgetLayout(widget, parentWidget, breakpoint) {
  const el = document.querySelector(`[data-widget-id="${widget.uid}"]`);
  if (!el || !el.offsetParent) return null;

  const marginLeftPx = alignmentMarginLeftPx(parentWidget, breakpoint, el.offsetParent.clientWidth);
  const y = Math.round(el.offsetTop);

  const x = isStretchedWidget(widget) ? 0 : Math.round(el.offsetLeft - marginLeftPx);

  const layout = _.cloneDeep(_.get(widget, `properties.${breakpoint}.layout`, {}));
  _.set(layout, 'transform.translate', `${x}px, ${y}px`);

  const { preserveSize } = WidgetRegistry.flexFlow(widget.type);
  if (!preserveSize) {
    _.set(layout, 'height', `${el.offsetHeight}px`);
  }

  return layout;
}

export function captureFreeformLayouts(widgets, rootId, breakpoint) {
  const byId = _.keyBy(widgets, 'uid');
  return flowedDescendants(widgets, rootId, breakpoint)
    .map(widget => {
      const layout = freezeWidgetLayout(widget, byId[widget.parent], breakpoint);
      return layout && { uid: widget.uid, breakpoint, layout };
    })
    .filter(Boolean);
}

export function captureRootContentHeight(widgets, rootId, breakpoint) {
  const el = document.querySelector(`[data-widget-id="${rootId}"]`);
  if (!el) return [];

  const widget = _.find(widgets, { uid: rootId });
  if (!widget || WidgetRegistry.flexFlow(widget.type).preserveSize) return [];

  const layout = _.cloneDeep(_.get(widget, `properties.${breakpoint}.layout`, {}));
  _.set(layout, 'height', `${el.offsetHeight}px`);
  return [{ uid: rootId, breakpoint, layout }];
}
  
export function resyncMoveableTargets(session) {
  if (!session) return;

  requestAnimationFrame(() => {
    session.eventBus?.trigger('refreshTargets');
  });
}
